import {
  IonIcon,
  IonImg,
  IonItem,
  IonList,
  IonMenu,
  IonMenuToggle,
} from "@ionic/react";

import { useHistory, useLocation } from "react-router-dom";
import {
  calendarOutline,
  calendar,
  fileTrayFullOutline,
  fileTrayFull,
  logOutOutline,
  logOut,
  gridOutline,
  grid,
  logoWhatsapp,
  peopleCircleOutline,
  peopleCircle,
  globeOutline,
  globe,
  peopleOutline,
  people,
} from "ionicons/icons";
import "./Menu.css";
import { useEffect, useState } from "react";
import ModalPacienteForm from "../ModalFormPaciente/ModalFormPaciente";
import { Link, Typography } from "@mui/joy";
import { Column, Row } from "../../basicsComponents/MaterialGridComponents";
import { createOutline } from "ionicons/icons";
import "./Menu.css";

const appPages = [
  {
    title: "Inicio",
    url: "/portal/Inicio",
    iosIcon: gridOutline,
    mdIcon: grid,
  },
  {
    title: "Reservar Turno",
    url: "/portal/Reservar turno",
    iosIcon: peopleCircleOutline,
    mdIcon: peopleCircle,
  },
  {
    title: "Horarios Prestadores",
    url: "/portal/Horarios",
    iosIcon: peopleOutline,
    mdIcon: people,
  },
  {
    title: "Mis Turnos",
    url: "/portal/Turnos",
    iosIcon: calendarOutline,
    mdIcon: calendar,
  },
  {
    title: "Mis Estudios",
    url: "/portal/Estudios",
    iosIcon: fileTrayFullOutline,
    mdIcon: fileTrayFull,
  },
];

const Menu = () => {
  const location = useLocation();
  const [usuario, setUsuario] = useState({});
  const [openModalPaciente, setOpenModalPaciente] = useState(false);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir === true) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();
  useEffect(() => {
    try {
      setUsuario(JSON.parse(sessionStorage.getItem("ppUL")));
    } catch {
      history.push({ pathname: "/ErrorPage" });
    }
  }, []);

  useEffect(() => {
    if (usuario.nombre !== "") {
      if (history.location.state?.justLogin === true) {
        history.location.state = {};
        setOpenModalPaciente(true);
      }
    }
  }, [usuario, history]);

  return (
    <IonMenu contentId="main" type="overlay">
      <Row container>
        {/* <IonContent> */}
        <img className="logo" src="assets/logo-cuadradoB.png" loading="lazy" />

        <div
          onClick={() => setOpenModalPaciente(true)}
          style={{
            cursor: "pointer",
          }}
        >
          <br />
          <Typography
            level="title-lg"
            className="encabezado"
            sx={{ color: "#1a336e" }}
            /*sx={{ color: "#1a336e" }}*/
          >
            {usuario.apellido}, {usuario.nombre}
          </Typography>
          <Typography
            level="title-md"
            className="encabezado"
            sx={{ color: "#1a336e" }}
          >
            {usuario.email}
            <IonIcon
              icon={createOutline}
              style={{ fontSize: "24px", color: "#044f9b", marginLeft: "10px" }}
            />
          </Typography>
        </div>
        <IonList id="inbox-list" style={{ marginTop: "7.5px" }}>
          {appPages.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false}>
                <IonItem
                  className={
                    location.pathname === appPage.url ? "selected" : ""
                  }
                  routerLink={appPage.url}
                  routerDirection="none"
                  lines="none"
                  detail={false}
                >
                  <IonIcon
                    aria-hidden="true"
                    slot="start"
                    ios={appPage.iosIcon}
                    md={appPage.mdIcon}
                  />
                  <Typography
                    sx={{
                      color:
                        location.pathname === appPage.url ? "#1a336e" : "#000",
                    }}
                    level={
                      location.pathname === appPage.url
                        ? "title-md"
                        : "title-sm"
                    }
                  >
                    {appPage.title.toUpperCase()}
                  </Typography>
                </IonItem>
              </IonMenuToggle>
            );
          })}
          <IonItem button lines="none" className="amarillo-sol">
            <IonIcon slot="start" icon={logoWhatsapp} />
            <Typography level={"title-sm"}>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://web.whatsapp.com/send?phone=+5493512297252&text=Hola!%20quiero%20hacer%20una%20consulta!"
              >
                {`Nuestro Whatsapp`.toUpperCase()}
              </a>
            </Typography>
            <IonIcon slot="end" ios={globeOutline} md={globe} />
          </IonItem>
          <IonItem button lines="none" routerLink={"/"}>
            <IonIcon
              aria-hidden="true"
              color="solid"
              slot="start"
              ios={logOutOutline}
              md={logOut}
            />
            <Typography variant="title-sm" color="danger">
              {`Cerrar Sesión`.toUpperCase()}
            </Typography>
          </IonItem>
        </IonList>
        {/* </IonContent> */}
      </Row>

      <Row container justifyContent="center" alignItems="center">
        <Column container justifyContent="space-between" alignItems="center">
          <Link
            href="https://www.gacitua.com.ar/"
            rel="Proveedor del servicio noreferrer"
            target="_blank"
          >
            <Typography level="title-lg">
              <Typography color="neutral"> {"Powered by "}</Typography>
              <img
                src={"assets/logoGacitua.png"}
                alt="logo gacitua y asociados"
                width={17}
                height={17}
                loading="lazy"
              />
              <Typography> {" Gacitua & Asociados"}</Typography>
            </Typography>
          </Link>
        </Column>
      </Row>

      <ModalPacienteForm
        openModal={openModalPaciente}
        setOpenModal={setOpenModalPaciente}
        mostrarNotificacion={mostrarNotificacion}
        paciente={usuario}
        setPaciente={setUsuario}
      />
    </IonMenu>
  );
};

export default Menu;
